<template>
    <prime-dialog
        class="generic-dialog"
        dismissable-mask
        modal
        v-model:visible="visible"
        :draggable="false"
        @hide="close"
    >
        <template #header>
            <h4>{{ title }}</h4>
        </template>
        <div class="alert-wrapper">
            <div class="text-wrapper" v-if="accessDeniedModal.modalType === 'expiredToken'">
                <p>Your access token for Enact has expired.</p>
                <p>
                    This may be due to your computer having been asleep for an extended period of time, your internet having a
                    brief outage, or your access being revoked.
                </p>
                <p>In order for Enact to continue to work, we require you to please refresh your page so you can log-in again.</p>
                <p>Closing this pop-up will refresh the page.</p>
            </div>

            <template v-if="accessDeniedModal.modalType === 'release'">
                <div v-html="accessDeniedModal.text" />
            </template>
        </div>
    </prime-dialog>
</template>

<script setup lang="ts">
import { useAlertStore } from '@/stores/alertStore.ts';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import PrimeDialog from 'primevue/dialog';

const alertStore = useAlertStore();
const router = useRouter();

const visible = defineModel<boolean>('visible');

const accessDeniedModal = computed(() => alertStore.accessDeniedModal);

const title = computed(() => {
    switch (accessDeniedModal.value.modalType) {
        case 'expiredToken':
            return 'Enact Token Expired';
        case 'release':
            return 'Enact Message';
        default:
            return 'Enact Access Denied';
    }
});

function close (): void {
    switch (accessDeniedModal.value.modalType) {
        case 'expiredToken':
            router.push('/login');
            break;
        case 'release':
            alertStore.setShowAccessDeniedModal(false);
            break;
    }
}

</script>

<style lang="scss" scoped>
.alert-wrapper {
    padding: var(--largeSpacing);
}
.text-wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--defaultSpacing);
    padding-top: var(--largeSpacing);
}
</style>
